module.exports = __webpack_public_path__ + "img/lg_ring_y_0_0_0@3x.3c5f39f9.png";